import { Routes, AppControllers } from './helpers/config_keys';

let AppRoutes = ($stateProvider: any,
    $urlRouterProvider: angular.ui.IUrlRouterProvider,
    $httpProvider: angular.IHttpProvider,
    $locationProvider: angular.ILocationProvider) => {
    $stateProvider
        .state(Routes.Login, {
            url: '/login',
            template: require('./authentication/login.html'),
            controller: AppControllers.LoginCtrl,
            controllerAs: 'loginVm',
            menu: '',
            authorize: false,
            permission: ''
        })
        .state(Routes.UnAuthorized, {
            url: '/unauthorized',
            template: require('./authentication/unauthorized.html'),
            menu: '',
            authorize: false,
            permission: ''
        })
        .state(Routes.ChangePassword, {
            url: '/changePassword',
            template: require('./user_profile/change_password.html'),
            controller: AppControllers.UserProfileCtrl,
            controllerAs: 'profileVm',
            menu: '',
            authorize: true,
            permission: ''
        })
        .state(Routes.Dashboard, {
            url: '/dashboard',
            template: require('./main/dashboard.html'),
            controller: AppControllers.DashboardCtrl,
            controllerAs: 'dashboardVm',
            menu: 'dashboard',
            authorize: true,
            permission: ''
        })
        .state(Routes.Members, {
            url: '/members',
            template: require('./members/members.html'),
            controller: AppControllers.MemberCtrl,
            controllerAs: 'memberVm',
            menu: 'members',
            authorize: true,
            permission: 'Member.Read'
        })
        .state(Routes.MemberAccount, {
            url: '/memberaccount/:id',
            template: require('./members/member_account.html'),
            controller: AppControllers.MemberAccountCtrl,
            controllerAs: 'memberVm',
            menu: 'members',
            authorize: true,
            permission: 'Member.Read'
        })
        .state(Routes.Transactions, {
            url: '/transactions',
            template: require('./transactions/transactions.html'),
            controller: AppControllers.TransactionCtrl,
            controllerAs: 'transactionVm',
            menu: 'transactions',
            authorize: true,
            permission: 'Transaction.Read'
        })
        .state(Routes.TransactionForm, {
            url: '/transaction/:type',
            template: require('./transactions/transaction_form.html'),
            controller: AppControllers.TransactionFormCtrl,
            controllerAs: 'transactionVm',
            menu: 'transactions',
            authorize: true,
            permission: 'Transaction.Create'
        })
        .state(Routes.Investments, {
            url: '/investments',
            template: require('./investments/investments.html'),
            controller: AppControllers.InvestmentsCtrl,
            controllerAs: 'investmentVm',
            menu: 'investments',
            authorize: true,
            permission: 'Investment.Read'
        })
        .state(Routes.Investment, {
            url: '/investment/:id',
            template: require('./investments/investment.html'),
            controller: AppControllers.InvestmentCtrl,
            controllerAs: 'investmentVm',
            menu: 'investments',
            authorize: true,
            permission: 'Investment.Read'
        })
        .state(Routes.Reports, {
            url: '/reports',
            template: require('./reports/reports.html'),
            controller: 'ReportsCtrl',
            controllerAs: 'reportsVm',
            menu: 'reports',
            authorize: true,
            permission: 'Report'
        })
        .state(Routes.ReportViewer, {
            url: '/report/:reportName',
            template: require('./reports/report_viewer.html'),
            controller: 'ReportViewerCtrl',
            controllerAs: 'rptViewerVm',
            menu: 'reports',
            authorize: true,
            permission: 'Report'
        })
        .state(Routes.Settings, {
            url: '/settings',
            template: require('./settings/settings.html'),
            controller: AppControllers.SettingsCtrl,
            controllerAs: 'settingsVm',
            menu: 'settings',
            authorize: true,
            permission: ''
        })
        .state(Routes.GenericSettings, {
            url: '/:setting',
            template: require('./settings/generic_grid.html'),
            controller: AppControllers.SettingCtrl,
            controllerAs: 'settingVm',
            menu: 'settings',
            authorize: true,
            permission: ''
        })
        .state(Routes.DataUploads, {
            url: '/data/uploads',
            template: require('./settings/data_upload.html'),
            controller: 'DataUploadCtrl',
            controllerAs: 'uploadVm',
            menu: 'settings',
            authorize: true,
            permission: 'Setting'
        })
        .state(Routes.Admin, {
            url: '/admin',
            template: require('./admin/admin.html'),
            controller: AppControllers.UsersCtrl,
            controllerAs: 'usersVm',
            menu: 'admin.users',
            authorize: true,
            permission: ''
        })
        .state(Routes.Users, {
            url: '/users',
            template: require('./admin/users.html'),
            controller: AppControllers.UsersCtrl,
            controllerAs: 'usersVm',
            menu: 'admin.users',
            authorize: true,
            permission: ''
        })
        .state(Routes.Roles, {
            url: '/roles',
            template: require('./admin/roles.html'),
            controller: AppControllers.RolesCtrl,
            controllerAs: 'rolesVm',
            menu: 'admin.users',
            authorize: true,
            permission: ''
        })

    $locationProvider.hashPrefix('');
    $urlRouterProvider.otherwise("dashboard");
    $httpProvider.interceptors.push("RequestInterceptor")
}

AppRoutes.$inject = ['$stateProvider', '$urlRouterProvider', '$httpProvider', '$locationProvider']

export { AppRoutes }


// WEBPACK FOOTER //
// ./app/app_routes.ts